import submitCommand from '../../../services/submitCommand';
import { uploadTextStepImage } from '../api/uploadTextStepImage';
import { CourseStep } from '../models/course';

export const editStepNameAndDescription = (
  courseId: string,
  existingStep: CourseStep | undefined,
  stepName: string,
  stepDescription: string,
  order: number,
  initiatingUserId: string
): Promise<CourseStep> => {
  return uploadTextStepImage(stepDescription).then(updatedDescription => {
    return submitCommand(
      courseId,
      {
        id: courseId,
        taskId: existingStep?._id.id || '',
        taskName: stepName,
        taskDescription: updatedDescription,
        initiatingUserId: initiatingUserId,
      },
      'SetTaskNameAndDescription',
      'NameAndDescriptionSetForTask',
      'TaskListError'
    ).then(
      () =>
        ({
          ...(existingStep || {}),
          order,
          taskName: stepName,
          taskDescription: updatedDescription,
        } as CourseStep)
    );
  });
};
